import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor,store } from 'store'

import { setUserToken } from 'services/authSlice'
import { materialTheme } from 'utils/materialTheme'

import '@total-typescript/ts-reset'

import App from './App'
import reportWebVitals from './reportWebVitals'

import './index.css'

store.dispatch(setUserToken())

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <ThemeProvider theme={materialTheme}>
      <Provider store={store}>
        {/* @ts-ignore */}
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
)

const scheduleSentryInit = () => {
  void import('./ instrument').then(({ initSentry }) => {
    void initSentry()
  })
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(scheduleSentryInit)
} else {
  setTimeout(scheduleSentryInit, 0)
}

reportWebVitals()
